module.exports = __webpack_public_path__ + "static/media/goal-setting.43826f76.png";